

import React, { useEffect, useState } from "react"; 
import ReactSelect from "react-select";
import { customStyles } from "../../selectStyles";

const Sidebar = ( props) => {
 
  return (
    <>
      <div className="widget-filter st2  style-scroll  settings mt-2">
        <form>
          <div className="group-form">
            <label className="title">Search Job</label>
            <div className="group-input search-ip">
              <button>
                <i className="icon-search"></i>
              </button>
              <input
                type="text"
                placeholder="Job title, key words or company"
                required
                className=" Dark-Input-from-group"
                onChange={(e) => {
                  props.setSearchNew(e.target.value);
                }}
                value={props.searchNew}
              />
            </div>
          </div>
          <div className="group-form">
            <label className="title">Company</label>
            <div className="group-input has-icon Svg-Arrow-Class">
              <ReactSelect
                options={props.getcompaniesList}
                onChange={props.handleCompany}
                value={
                  props.getcompaniesList.find(
                    (option) => option.value === props.selectedcompaniesId
                  ) || null
                }
                placeholder="Select Company Type"
                styles={customStyles}
                classNamePrefix="react-select"
                className="form-control"
                isClearable
              />
            </div>
          </div>

          <div className="group-form">
            <label className="title">City</label>
            <div className="group-input has-icon Svg-Arrow-Class">
              {/* <i className="icon-map-pin"></i> */}
              <ReactSelect
                options={props.cityList}
                onChange={props.handleCitySelect}
                value={
                  props.cityList.find(
                    (option) => option.value === props.cityId
                  ) || null
                }
                placeholder="Select city"
                styles={customStyles}
                classNamePrefix="react-select"
                className="form-control "
                isClearable
              />
              {/* <SelectLocation /> */}
            </div>
          </div>

          <div className="group-form">
            <label className="title">Job Types</label>
            <div className="group-input Svg-Arrow-Class">
              <ReactSelect
                options={props.jobTypeList}
                onChange={props.handleJobType}
                value={
                  props.jobTypeList.find(
                    (option) => option.value === props.selectedJobTypeId
                  ) || null
                }
                placeholder="Select JobType"
                styles={customStyles}
                classNamePrefix="react-select"
                className="form-control"
                isClearable
              />
            </div>
          </div>
          <div className="group-form">
            <label className="title">Work Level Type</label>
            <div className="group-input Svg-Arrow-Class">
              <ReactSelect
                options={props.workLevelList}
                onChange={props.handleWorkLevel}
                value={
                  props.workLevelList.find(
                    (option) => option.value === props.selectedworkLevelId
                  ) || null
                }
                placeholder="Select Work Level"
                styles={customStyles}
                classNamePrefix="react-select"
                className="form-control"
                isClearable
              />
            </div>
          </div>
          <div className="group-form">
            <label className="title">Work Location Type</label>
            <div className="group-input Svg-Arrow-Class">
              <ReactSelect
                options={props.workLocation}
                onChange={props.handleWorkLoc}
                value={
                  props.workLocation.find(
                    (option) => option.value === props.selectedCategoryId
                  ) || null
                }
                placeholder="Select Location Type"
                styles={customStyles}
                classNamePrefix="react-select"
                className="form-control"
                isClearable
              />
            </div>
          </div>

          <div className="group-form">
            <label className="title"> Designation</label>
            <div className="group-input Svg-Arrow-Class">
              <ReactSelect
                options={props.designationList}
                onChange={props.handleDesignation}
                value={
                  props.designationList.find(
                    (option) => option.value === props.selectedDesignationId
                  ) || null
                }
                placeholder="Select Designation Type"
                styles={customStyles}
                classNamePrefix="react-select"
                className="form-control"
                isClearable
              />
            </div>
          </div>
          <div className="group-form">
            <label className="title">SalaryType</label>
            <div className="group-input Svg-Arrow-Class">
              <ReactSelect
                options={props.salaryTypeList}
                onChange={props.handleSalaryType}
                value={
                  props.salaryTypeList.find(
                    (option) => option.value === props.selectedSalaryTypeId
                  ) || null
                }
                placeholder="Select Location Type"
                styles={customStyles}
                classNamePrefix="react-select"
                className="form-control"
                isClearable
              />
            </div>
          </div>

          
 
        </form>
      </div>
    </>
  );
};

export default Sidebar;
